import { useContext, useEffect, useRef, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import helpers from "src/utils/helpers"
import { Filter, Portal, ServerSideTable } from "src/component"
import { AppText, Button, CustomContainer, FlexRow } from "src/style"
import {tagsColumns, tagsData} from 'src/utils/table-layout'
import { Add_Edit_Tag } from "src/popup"
// import NotifierComponents from 'react-pop-notifier';
// const { useNotifier } = NotifierComponents;
import { useNotifier } from "react-pop-notifier"

export const Tags = () => {
    const {API, downloadReport} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {notifier} = useNotifier()
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const [view, setView] = useState<string>('')
    
    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = {data: tagsData, total: 4}

        if (response) {
            if (isDownload) {
                return downloadReport(response, 'TAGS_REPORT')
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    function handleRowAction (row: any, actionType: string) {
        if (actionType === 'edit') {
            setView('edit-tag')
            setSelectedRow(row)
        }
        else {
            decisionBox.show(
                `Are you sure you want to disable this tag?`,
                handleDisableTag,
                decisionBox.hide,
                `Yes, Disable`,
                'No'
            )
        }
    }

    function handleDisableTag () {
        notifier.show('Tag Successfully Disabled', null, 'success')
    }

    return (
        <>
            <CustomContainer>
                <FlexRow 
                    justifyContent='space-between' alignItems='flex-start' 
                    bottomMargin='1.5' gap='1.5' wrap='wrap'
                >
                    <AppText textSize='2' color='#101828' fontWeight="500">
                        Tags
                    </AppText>
                    <Button
                        width='12.2' fontWeight="500"
                        height='4' radius='0.8' hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={() => setView('new-tag')}
                    >
                        Add New Tag
                    </Button>
                </FlexRow>
                <ServerSideTable
                    tableData={report}
                    tableColumns={tagsColumns(handleRowAction)} 
                    dataFetchMethod={handleFetchReport}
                    totalRows={reportData?.total}
                    customStyle
                    shouldResetPagination={resetPagination}
                    canFilter={() => setView('filter')}
                    canClear={handleClear}
                    downloadAction={() => handleFetchReport(1, 10, true)}
                />
            </CustomContainer>
            { view === 'filter' &&
                <Portal>
                    <Filter
                        type='tags'
                        onApplyFilter={handleFetchReport}
                        setFilterData={(data: any) => {filterDataRef.current = data}}
                        close={() => setView('')}
                    />
                </Portal>
            }
            { ['new-tag' ,'edit-tag'].includes(view) &&
                <Add_Edit_Tag 
                    getTags={() => {
                        filterDataRef.current = {};
                        handleFetchReport()
                    }}
                    rowData={selectedRow}
                    close={() => setView('')}
                />
            }
        </>
    )
}